import { useTranslation } from "react-i18next";

import { IRuleDeviceOfflineConditions } from "interfaces/rules.interface";

import { InfoField } from "./InfoField";

type LogPresetDeviceOfflineProps = {
  preset: IRuleDeviceOfflineConditions;
};

export function LogPresetDeviceOffline({
  preset,
}: LogPresetDeviceOfflineProps) {
  const { t } = useTranslation();

  return (
    <InfoField
      label={t("downtime_is_greater_than_or_equal_to")}
      value={(preset.time_since_last_seen_gte ?? 0) / 60}
      unit={t("mins")}
    />
  );
}
